<template>
  <v-dialog
    v-model="dialog"
    max-width="900"
    :fullscreen="$vuetify.breakpoint.mobile"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-tooltip v-bind="attrs" v-on="on" top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            rounded
            v-on="on"
            v-bind="attrs"
            small
            @click="openSetResult"
            :loading="fetchingOddsForEvent === event.event_id"
            :disabled="fetchingOddsForEvent > 0"
          >
            <v-icon :color="$vuetify.theme.dark ? '' : 'primary'">
              mdi-pencil
            </v-icon>
          </v-btn>
        </template>
        <span>
          {{ $t("createNewEvent.updateResult") }}
        </span>
      </v-tooltip>
    </template>
    <v-card>
      <v-toolbar
        flat
        tile
        class="flex-grow-0"
        :style="$vuetify.theme.dark ? '' : 'border-bottom: 0.5px solid #ccc;'"
      >
        <v-toolbar-title class="title">
          {{ $t("createNewEvent.updateResult") }}
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <div class="px-4 py-4">
          <div class="body-2 px-4 pt-2 d-flex flex-column pb-4">
            <span class="text-h6">
              {{ $t("sport") }}
            </span>
            <div class="body-2 pt-2 d-flex flex-column pb-4 pl-4">
              <span class="pl-2">{{ event.sport_name }}</span>
            </div>
          </div>
          <div class="body-2 px-4 pt-2 d-flex flex-column pb-4">
            <span class="text-h6">
              {{ $t("league") }}
            </span>
            <div class="body-2 pt-2 d-flex flex-column pb-4 pl-4">
              <span class="pl-2">{{ event.league_name }}</span>
            </div>
          </div>
          <div class="body-2 px-4 pt-2 d-flex flex-column pb-4">
            <span class="text-h6">
              {{ $t("event") }}
            </span>
            <div class="body-2 pt-2 d-flex flex-column pb-4 pl-4">
              <span>
                {{ event.teams.split("X")[0] }} x
                {{ event.teams.split("X")[1] }}
              </span>
              <span>
                <v-icon small class="pr-1">
                  mdi-calendar
                </v-icon>
                <span>
                  {{
                    event.event_date
                      ? event.event_date.split(" ")[0].replace(",", "")
                      : ""
                  }}
                </span>
              </span>
              <span>
                <v-icon small class="pr-1">
                  mdi-clock
                </v-icon>
                <span>
                  {{
                    event.event_date
                      ? event.event_date.split(" ")[1].slice(0, -3)
                      : ""
                  }}
                </span>
              </span>
            </div>
          </div>
        </div>

        <div class="px-8 ">
          <v-divider class="py-4" />
          <v-alert
            v-if="Object.keys(disabledSetWinnerOdd).length > 0"
            :type="disabledSetWinnerOdd.type"
            dense
            border="left"
            :text="!$vuetify.theme.dark"
          >
            {{ disabledSetWinnerOdd.text }}
          </v-alert>

          <span class="text-h5 font-weight-bold">
            {{ $t("createNewEvent.form.selectWinnerOdd") }}
          </span>

          <div class="d-flex flex-start" style="gap: 100px">
            <v-radio-group
              v-model="winnerOddId"
              v-for="odd in odds"
              :key="odd.value"
            >
              <v-radio
                :value="odd.odd_id"
                :disabled="
                  confirmResult || Object.keys(disabledSetWinnerOdd).length > 0
                "
              >
                <div slot="label">
                  <div class="d-flex flex-column">
                    <span class="text-capitalize">
                      {{ odd.description }}
                    </span>
                    <span>{{ odd.odd_price }}</span>
                  </div>
                </div>
              </v-radio>
            </v-radio-group>
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="pr-4 pb-4" v-if="!confirmResult">
        <v-spacer></v-spacer>
        <v-btn class="white black--text" @click="closeDialog">
          {{ $t("toCancel") }}
        </v-btn>
        <v-btn
          color="primary"
          @click="preSetResult"
          :loading="settingResult"
          :disabled="
            settingResult ||
              !winnerOddId ||
              Object.keys(disabledSetWinnerOdd).length > 0
          "
        >
          {{ $t("toConfirm") }}
        </v-btn>
      </v-card-actions>
      <v-card-actions class="pr-4 pb-4" v-else>
        <v-spacer></v-spacer>
        <span class="pr-2">
          {{ $t("createNewEvent.confirmUpdateResult", { selectedOdd }) }}
        </span>
        <v-btn @click="setResult" color="info"> {{ $t("yes") }} &nbsp; </v-btn>
        <v-btn @click="confirmResult = false" class="white black--text">
          {{ $t("no") }} &nbsp;
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["event", "fetchingOddsForEvent"],
  data: () => ({
    dialog: false,
    loading: false,
    odds: [],
    winnerOddId: null,
    confirmResult: false,
    settingResult: false,
    selectedOdd: "",
  }),

  watch: {
    winnerOddId(val) {
      if (val) {
        const odd = this.odds.find((odd) => odd.odd_id == val);
        this.selectedOdd = odd.odd_id;
      }
    },
    dialog(val) {
      if (!val) {
        this.winnerOddId = null;
      }
    },
  },

  computed: {
    disabledSetWinnerOdd() {
      const now = new Date();
      const eventDate = new Date(this.event.realDate);
      const hasNotStarted = eventDate > now;

      if (this.event.status == "1" && hasNotStarted) {
        return {
          text: this.$t("createNewEvent.selectWinnerAlert.hasNotStarted"),
          type: "info",
        };
      }

      if (this.event.status == "3") {
        return {
          text: this.$t("createNewEvent.selectWinnerAlert.finished"),
          type: "success",
        };
      }

      return false;
    },
  },

  methods: {
    openSetResult() {
      if (this.fetchingOddsForEvent > 0) {
        return;
      }

      const eventId = this.event.event_id;

      this.$emit("fetchingEventOdds", eventId);

      const body = {
        event_id: eventId,
      };

      this.$axios
        .post(
          `/${this.$prefix()}/manualEvents/odds/getOdds`,
          this.$formdata(body)
        )
        .then((res) => {
          this.dialog = true;
          const winnerOdd = res.data.dados.find((odd) => odd.odd_result == "1");

          if (winnerOdd) {
            this.winnerOddId = winnerOdd.odd_id;
          }

          this.odds = res.data.dados;
        })
        .finally(() => {
          this.$emit("fetchingEventOdds", 0);
        });
    },

    preSetResult() {
      this.confirmResult = true;
    },

    setResult() {
      this.confirmResult = false;
      this.settingResult = true;

      const body = {
        event_id: this.event.event_id,
        odd_id: this.winnerOddId,
      };

      this.$axios
        .post(
          `/${this.$prefix()}/manualEvents/odds/setWinningOdd`,
          this.$formdata(body)
        )
        .then((res) => {
          this.$store.commit("setFeedbackSnack", {
            msg: res.data.messages,
            color: "success",
          });

          this.$emit("refresh");

          this.dialog = false;
        })
        .finally(() => {
          this.settingResult = false;
        });
    },

    closeDialog() {
      this.dialog = false;
    },

    getLegendByBetTypeId(betTypeId) {
      const map = {
        "1": "Casa",
        "2": "Empate",
        "3": "Fora",
      };

      return map[betTypeId];
    },
  },
};
</script>
